import actions from "./actions"
import mutations from "./mutations"
import getters from "./getters"

const state = {
  currentMember: {
    data: null,
    error: null,
    loading: false,
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
